<template>
    <div class="card shadow-sm"
        @click.prevent="select(data)"
        >
        <div class="card-body rounded-5 p-2rem">
            <img :src="`/resources/images/usecases/` + data.image" class="rounded-circle mb-3" alt="">
            <h5 class="card-title text-black">{{ data.name }}</h5>
            <p class="card-text fs-6">{{ data.description }}</p>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        data: {
            type: Object,
            default() {
                return {
                    name: '...',
                    description: '...'
                }
            }
        },
        select: {
            type: Function,
            default() {
                return function(){};
            }
        }
    }, 

    data() {
        return {

        }
    }

}
</script>

<style scoped>

.p-2rem {
    padding: 2rem!important;
}

.card {
    width: 32%;
    margin-right: 1%;
    background-color: #fcfcfd;
    transition: all 0.15s;
}
.card:hover {
    border-color: #aaa;
    background-color: #fff;
    cursor: pointer;
    box-shadow: 0 4px 8px #404fff2b !important;
}
.card.active {
    pointer-events: none;
    background-color: #404fff;
    border-color: #404fff;
    color: #fff;
}


.card img {
    width: 64px;
    padding: 1px;
}
</style>